"use strict";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

Shopify.theme.jsCart = {
  init: function init($section) {
    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section;
    $(document).on("click", "[data-cart-page-delete]", function (e) {
      e.preventDefault();
      var lineKey = $(this).data("cart-item-key");
      if ($(this).data("cart-item-group")) Shopify.theme.jsCart.removeByBundle(
        $(this).data("cart-item-group")
      );
      else Shopify.theme.jsCart.removeFromCart(
        lineKey,
        $(this).data("cart-item-group")
      );
      return false;
    }); // Prevent the ajax cart form from being submitted when pressing the "Enter" key

    $("#cart_form").keydown(function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeByBundle: function (bundleName, cart = false) {
    if (!cart) {
      $.post('cart', x => {
        Shopify.theme.jsCart.removeByBundle(bundleName, x);
      });
    } else {
      var id = false;
      if (cart && cart.items) for (const item of cart.items) {
        if (item?.properties?.Bundle == bundleName) {
          if (item.price > 0 && !bundleName.includes(item.handle)) continue;
          id = item.key;
          break;
        }
      }
      if (id) $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { quantity: 0, id },
        dataType: "json",
        success: function (x) {
          Shopify.theme.jsCart.removeByBundle(bundleName, x);
        },
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
        },
      });
      else Shopify.theme.jsCart.updateView(cart);
    }
    return true;
  },
  removeFromCart: async function removeFromCart(lineKey, group = false) {
    if (group) {
      const searchTxt = `[data-cart-item-group="${group}"]`;
      var cartItems = Shopify.theme.jsCart.$section.find(searchTxt);
      var ids = [];
      cartItems;
      cartItems.each(function () {
        $(this).parents(".item-container").css("opacity", "0.5");
        ids.push($(this).data("cart-item-key"));
      });
      var cart = false;
      for (const id of ids) {
        await $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { quantity: 0, id },
          dataType: "json",
          success: function (resp) {
            cart = resp;
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError);
          },
        });
      }
      Shopify.theme.jsCart.updateView(cart);
    } else {
      var $cartItem = Shopify.theme.jsCart.$section.find(
        '[data-line-item="'.concat(lineKey, '"]')
      );
      console.log("testing");
      $cartItem.css("opacity", "0.5");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + lineKey,
        dataType: "json",
        success: function success(cart) {
          $cartItem.addClass("animated zoomOut");
          $cartItem.remove();
          Shopify.theme.jsCart.updateView(cart, lineKey);

          if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
            Shopify.theme.jsAjaxCart.updateView();
          }
        },
        error: function error(XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    }
  },
  updateView: function updateView(cart, lineKey) {
    if (cart.item_count > 0) {
      var _$$ajax;

      $.ajax(
        ((_$$ajax = {
          dataType: "json",
          async: false,
          cache: false,
        }),
          _defineProperty(_$$ajax, "dataType", "html"),
          _defineProperty(_$$ajax, "url", "/cart"),
          _defineProperty(_$$ajax, "success", function success(html) {
            if (lineKey !== null) {
              var updatedItems = $(html).find(".cart__item-list .cart__card");
              var currentItems = $(".cart__item-list .cart__card");

              if (updatedItems.length != currentItems.length) {
                var updatedCartList = $(html).find(".cart__item-list");
                $(".cart__item-list").replaceWith(updatedCartList);
              }

              if (false)
                $(currentItems).each(function (index, element) {
                  $(element).attr("data-line-item", index + 1);
                  $(element)
                    .find("[data-line-item-key]")
                    .attr("data-line-item-key", index + 1);
                });
              var itemTotal = $(html)
                .find('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".cart__total");
              var quantityInput = $(html)
                .find('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".quantity-input");
              var itemPrice = $(html)
                .find('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".cart__price");
              $('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".cart__total")
                .replaceWith(itemTotal);
              $('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".quantity-input")
                .replaceWith(quantityInput);
              $('[data-cart-item="'.concat(lineKey, '"]'))
                .find(".cart__price")
                .replaceWith(itemPrice);
            } else {
              var updatedCartList = $(html).find(".cart__item-list");
              $(".cart__item-list").replaceWith(updatedCartList);
            }

            var subtotal = $(html).find(".cart__subtotal-container");
            var discounts = $(html).find(".cart__discounts");
            var savings = $(html).find(".cart__total-savings");
            $(".cart__subtotal-container").replaceWith(subtotal);

            if (discounts.length > 0 && $(".cart__discounts").length < 1) {
              $(".cart__subtotal-container").before(discounts);
            } else {
              $(".cart__discounts").replaceWith(discounts);
            }

            if (savings.length > 0 && $(".cart__total-savings").length < 1) {
              $(".cart__subtotal-container").after(savings);
            } else {
              $(".cart__total-savings").replaceWith(savings);
            }

            $('[data-bind="itemCount"]').text(cart.item_count);
          }),
          _$$ajax)
      );
    } else {
      $(".cart__empty-cart-message").removeClass("is-hidden");
      $(".cart__form").addClass("is-hidden");
      $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
      $('[data-bind="itemCount"]').text("0");
    }
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $("[data-cart-page-delete]").off();
    $("#cart_form").off();
  },
};
